import React from 'react';
import { Box, Typography, Stack, Tooltip } from '@mui/material';
import { Code as CodeIcon, CalendarToday as CalendarIcon, Info as InfoIcon } from '@mui/icons-material';
// معلومات الإصدار
const APP_VERSION = '3.0';
const DEVELOPER = 'Ahmed Elswah';
const BUILD_DATE = new Date().toLocaleDateString('en-US');

// تحديد السنة الحالية
const CURRENT_YEAR = new Date().getFullYear();

const Footer: React.FC = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: 2,
        px: 2,
        mt: 'auto',
        backgroundColor: (theme) => theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[900],
        borderTop: (theme) => `1px solid ${theme.palette.divider}`,
        textAlign: 'center',
        borderRadius: '4px 4px 0 0',
        boxShadow: (theme) => `0 -1px 3px ${theme.palette.grey[300]}`
      }}
    >
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={{ xs: 1, sm: 2 }}
        justifyContent="center"
        alignItems="center"
        sx={{ flexWrap: { sm: 'wrap' } }}
      >
        <Typography variant="body2" color="text.secondary" align="center">
          {'حقوق الملكية © '}
          {CURRENT_YEAR}
        </Typography>

        <Tooltip title="المطور">
          <Stack direction="row" alignItems="center" spacing={0.5}>
            <CodeIcon fontSize="small" color="action" />
            <Typography variant="body2" color="text.secondary">
              {DEVELOPER}
            </Typography>
          </Stack>
        </Tooltip>

        <Tooltip title="رقم الإصدار">
          <Stack direction="row" alignItems="center" spacing={0.5}>
            <InfoIcon fontSize="small" color="action" />
            <Typography variant="body2" color="text.secondary">
              {APP_VERSION}
            </Typography>
          </Stack>
        </Tooltip>

        <Tooltip title="تاريخ البناء">
          <Stack direction="row" alignItems="center" spacing={0.5}>
            <CalendarIcon fontSize="small" color="action" />
            <Typography variant="body2" color="text.secondary">
              {BUILD_DATE}
            </Typography>
          </Stack>
        </Tooltip>
      </Stack>
    </Box>
  );
};

export default Footer;
